import React, { useState } from 'react'
import Container from '@mui/material/Container'
import { isEmpty, showToast, validatePassword } from '../utils/AppHelper'
import { Grid } from '@mui/material'
import { Box } from '@mui/material'

import { TextBold } from '../commonComponents/TextStyling'
import AppButton from '../commonComponents/AppButton'
import { useLocation, useNavigate } from 'react-router'
import serverData from '../api/ServerData'
import { useTheme } from '@mui/styles'
import PasswordPopperComponent from '../commonComponents/PasswordPopperComponent'

function ResetPassword () {
  const theme = useTheme()
  const [newPassword, setNewPassword] = useState('')
  const [formError, setFormError] = useState({})
  const location = useLocation()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)

  function validateForm () {
    const error = {}
    if (isEmpty(newPassword)) {
      error.newPassword = 'Password cannot be empty'
    } else if (newPassword.length < 8) {
      error.newPassword = 'Password should be 8 characters long'
    } else if (!validatePassword(newPassword)) {
      error.newPassword =
        'Password should contain atleast a letter, number and special character'
    }

    setFormError(error)
    return Object.keys(error).length === 0
  }

  function resetPwd (event) {
    event.preventDefault()
    if (validateForm()) {
      const query = new URLSearchParams(location.search) // eslint-disable-next-line
      const token = query.get('token')
      var body = { token, password: newPassword }
      setLoading(true)
      serverData.resetPassword(
        body,
        result => {
          if (result.status) {
            showToast(result.message, false)
            navigate('/login')
          } else {
            showToast(result.message)
          }
          setLoading(false)
        },
        error => {
          setLoading(false)
          showToast(error?.statusText)
        }
      )
    }
  }

  return (
    <Container component='main' maxWidth='xl'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh'
        }}
      >
        <Grid
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 'auto',
            width: '40%',
            background: theme.palette.background.paper,
            borderRadius: '16px',
            padding: '32px'
          }}
        >
          <Box component='form' onSubmit={resetPwd} noValidate>
            <Grid
              item
              xs={12}
              style={{
                margin: '0rem 5rem',
                textAlign: 'center'
              }}
            >
              <TextBold style={{ fontSize: '22px' }}>
                Choose a new password
              </TextBold>
            </Grid>
            <Grid item xs={12}>
              <PasswordPopperComponent
                password={newPassword}
                setPassword={setNewPassword}
                formError={formError.newPassword}
                isPopper={true}
                title={'New password *'}
              />
            </Grid>

            <AppButton
              loading={loading}
              style={{
                marginTop: '20px',
                padding: '12px 27px',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: 400
              }}
              name={'Reset Password'}
              onClick={resetPwd}
            />
          </Box>
        </Grid>
      </Box>
    </Container>
  )
}

export default ResetPassword
